var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-synced email-synced--block" }, [
    _c("div", { staticClass: "email-synced__top" }, [
      _c("div", [
        _c("p", { staticClass: "email-synced__title" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Adresse email synchronisée")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "email-synced__content" }, [
          _vm._v(_vm._s(_vm.email))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showDisconnectButton
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("email.disconnect_my_email"),
                  type: "secondary-destructive",
                  size: "medium"
                },
                on: { click: _vm.logout }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email-synced__bottom" }, [
      _c("p", { staticClass: "email-synced__title" }, [
        _vm._v(_vm._s(_vm.$l10n.__("État de connexion")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "email-synced__state" },
        [
          _c("CompassTag", { attrs: { color: _vm.statusButtonStyle } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.syncStatus.message) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("CompassPlainButton", {
            attrs: {
              label: _vm.$t.__("email.EmailSettingAccountSynced.update")
            },
            on: { click: _vm.updateStatus }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }